import { Badge, type BadgeProps } from '@mantine/core';
import { statusToneToMantineColor, type StatusTone } from '../tokens/statusColorMap';
import { statusIcons } from '../icons/statusIcons';
import { iconSizes } from '../icons/iconTypes';

export interface StatusBadgeProps extends Omit<BadgeProps, 'color' | 'variant' | 'children'> {
  label: string;
  tone?: StatusTone;
  withIcon?: boolean;
}

/** Generic status chip — prefer domain badges for entity-specific statuses. */
export function StatusBadge({
  label,
  tone = 'neutral',
  withIcon = false,
  leftSection,
  ...props
}: StatusBadgeProps) {
  const Icon = statusIcons[tone === 'danger' ? 'error' : tone === 'neutral' ? 'neutral' : tone] ?? statusIcons.neutral;
  return (
    <Badge
      color={statusToneToMantineColor[tone]}
      variant="light"
      radius="xl"
      size="sm"
      fw={700}
      tt="none"
      leftSection={withIcon ? <Icon size={iconSizes.inline - 4} stroke={2} /> : leftSection}
      {...props}
    >
      {label}
    </Badge>
  );
}

export type { StatusTone };
